<header class="app-navbar" role="banner">
  <div class="inner-wrapper">
    <div class="nav-inner" role="navigation" aria-label="Primary">
      <div class="nav-left">
        <div class="brand-box" (click)="navigateTo('/homepage')" style="cursor: pointer; display:flex; align-items:center; gap:12px;">

          <div class="logo-wrapper">
            <ng-container *ngIf="!logoLoading; else loadingLogo">
              <img
                *ngIf="brandLogo; else genericLogo"
                [src]="brandLogo"
                alt="Utility Logo"
                class="logo-img"
              />
            </ng-container>
            <ng-template #genericLogo>
              <div class="logo-initial">
                {{ brand ? brand.charAt(0) : 'U' }}
              </div>
            </ng-template>
            <ng-template #loadingLogo>
              <div class="logo-placeholder"></div>
            </ng-template>
          </div>

          <div class="brand-text">{{ brand }}</div>
        </div>
      </div>

      <div class="spacer"></div>

      <div class="right-group">
        <nav class="nav-pill" aria-label="Main navigation">
          <button
            *ngFor="let item of navItems"
            class="nav-btn"
            [routerLink]="item.path"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            {{ item.label }}
          </button>
        </nav>

        <div class="icon-pill" role="group" aria-label="User actions">
          <div class="settings-container" #settingsDropdown>
            <button class="icon-btn" title="Settings" (click)="toggleSettings()">
              <img src="assets/F1.png" alt="Settings" class="icon-img" />
            </button>
            <div *ngIf="showSettingsDropdown" class="settings-dropdown">
              <button (click)="logout()">Logout</button>
            </div>
          </div>
          
          <button class="icon-btn" title="Notifications" (click)="onNotifications()">
            <img src="assets/F2.png" alt="Notifications" class="icon-img" />
          </button>
          
          <button 
            class="icon-btn" 
            title="Home" 
            [routerLink]="'/homepage'"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img src="assets/F_home.svg" alt="Home" class="icon-img" />
          </button>

          <button class="icon-btn" title="Account" (click)="onAccount()">
            <img src="assets/F3.png" alt="Account" class="icon-img" />
          </button>
        </div>
      </div>
    </div>
  </div>
</header>